module.exports = __webpack_public_path__ + "media/images/haircut/cover-mobile-c86dd3b457b1a4fe3a514d877840967f.jpg";